import { EasmBulkChangeInvestigationPropertyDataProvider } from './EasmBulkChangeInvestigationPropertyDataProvider';
import { translateFn } from '../../../utils/translator.helper';
import { FindingClassType } from '../../types';

export class EasmBulkChangeAssigneeDataProvider extends EasmBulkChangeInvestigationPropertyDataProvider {
  public getTitle(): string {
    return translateFn('Change assignee?');
  }

  public getDescription(findingsClassType: FindingClassType, preSelectedValueLabel: string | null): string {
    if (FindingClassType.ASSET === findingsClassType) {
      return null !== preSelectedValueLabel
        ? translateFn(
          'The assignee of the selected assets will change to <b>{assignee}</b>.',
          { assignee: preSelectedValueLabel }
        )
        : translateFn('Select an assignee for this asset.');
    } else {
      return null !== preSelectedValueLabel
        ? translateFn(
          'The assignee for the selected artifacts will change to <b>{assignee}</b>.',
          { assignee: preSelectedValueLabel }
        )
        : translateFn('Select the assignee for this artifact.');
    }
  }

  public getOptionsLabel(): string {
    return translateFn('Assignee');
  }

  public getOptionsPlaceholder(): string {
    return translateFn('Select assignee');
  }

  public getRequiredOptionErrorMessage(): string {
    return translateFn('Please select an assignee.');
  }

  public getApplyToArtifactsOptionLabel(): string {
    return translateFn('Apply the note and set the assignee also for asset artifacts.');
  }

  public getSuccessToastMessage(response: any): string {
    return translateFn('Assignee changed successfully');
  }

  public getFailureToastMessage(error: any, value: any): string {
    return translateFn('Failed to change the assignee');
  }

  protected getApiInvestigationProperty(): string {
    return 'assignedUser';
  }
}
